import { ILeaseCustomerRow, IResidentTableRow } from '@/types/admin/residentList';
import { capitalizeFirstLetter } from '@/utils/admin/utils';

export const getDateSubstr = (dateStr: string): string => {
  return dateStr.split('T')[0];
};

export const normalizeResidentRow = (row: ILeaseCustomerRow): IResidentTableRow => {
  const lease = row.lease;
  const account = row.account;

  const firstName = row.first_name ?? row.firstName;
  const lastName = row.last_name ?? row.lastName;
  const customerType = row.customer_type ?? row.customerType;
  const leaseId = row.lease_id ?? row.leaseId ?? lease?.id ?? 0;

  return {
    id: row.id,
    leaseId,
    name: firstName ? `${firstName} ${lastName ?? ''}`.trim() : 'No Details Found',
    lease_status: capitalizeFirstLetter(lease?.statusType ?? ''),
    unit: lease?.buildingUnitNumberSpace ?? lease?.unitNumberSpace ?? '',
    last_login: account?.lastInteractionDate
      ? new Date(getDateSubstr(account.lastInteractionDate))
      : null,
    last_payment: account?.lastPaymentDate
      ? new Date(getDateSubstr(account.lastPaymentDate))
      : null,
    autopay: (lease?.recurringPayments?.length ?? 0) > 0,
    customer_type: capitalizeFirstLetter(customerType ?? ''),
    accountId: row.id,
  };
};
